import { useChatHistoryStore } from '@/store/chatHistory';
import { connectWs } from '../socket';
import { EUserType, useUserStore } from '@/store';
import {
  getConversationId,
  normalizeIncomingChatMessage,
} from '../utils/tool';
import { i18nt } from '@/i18n';

type WsChatMessage = Record<string, unknown> & {
  chatType?: string;
  senderId?: string | number;
  senderUserType: EUserType.BZ | EUserType.TGZ
  messageType?: string;
  sessionId?: string;
};

const useWsChat = () => {
  const chatStore = useChatHistoryStore();
  const userStore = useUserStore();
  const startChat = async () => {
    try {
      await connectWs({
        onMessage: (raw) => {
          const message = raw as WsChatMessage;
          const supportChatTypes = [
            'person-message',
            'flow',
            'groupNotify',
          ];
          console.log(`${i18nt('sdxx')}=====`, message);
          if (!message.chatType || !supportChatTypes.includes(message.chatType)) {
            return;
          }


          const hasSenderUserType =
            message.senderUserType != null &&
            message.senderUserType !== '';

          const isCurrentUserMessage = hasSenderUserType
            ? message.senderUserType == userStore.user.type
            : message.senderId == userStore.user.userId;
          // 自己的发出的消息不用再次写入
          if (isCurrentUserMessage) return;

          // if (message.senderId == userStore.user.userId) return;

          const normalized = normalizeIncomingChatMessage(message);
          const conversationId = getConversationId(normalized);
          if (!conversationId) {
            console.warn('[ws] skip message: missing registrationId', message);
            return;
          }

          if (message.messageType !== 'reading') {
            chatStore.addOneMessage({
              ...normalized,
              conversationId,
              sessionId: String(normalized.sessionId ?? message.sessionId ?? ''),
              read: false,
            });
          } else {
            chatStore.updateOneMessage({
              conversationId,
              sessionId: message.sessionId,
              read: true,
            });
          }
        },
      });
    } catch (err) {
      console.log(i18nt('ljsb'), err);
    }
  };

  return {
    startChat,
  };
};
export default useWsChat;
